module.exports = __webpack_public_path__ + "img/hxz_left.515ce472.png";